import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras, NavigationStart } from '@angular/router';
import { ApisService } from 'src/app/services/apis.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  categories: string;
  logedIn: boolean;
  id: any;
  name: any;
  photo: any;
  cityName: any;
  cityId: any;
  cartData: any = 0;

  constructor(
    private router: Router,
    private api: ApisService,
    private util: UtilService,
  ) {
    this.logedIn = false;
    this.name = '';
    this.getProfile();
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        const city = JSON.parse(localStorage.getItem('selectedCity'));
        console.log(city);
        if (city && city.name) {
          // this.cityName = city.name;
          // this.cityId = city.id;
        } else {
          document.getElementById('btnClickHeader').click();
        }
        if (localStorage.getItem('uid')) {
          this.logedIn = true;
        } else {
          this.logedIn = false;
        }
      }
    });
    if (localStorage.getItem('totalItem')) {
      this.cartData = localStorage.getItem('totalItem');
    }
    this.util.cart$.subscribe((data) => {
      this.cartData = data;
    });

  }

  ngOnInit(): void {

    if (localStorage.getItem('uid')) {
      this.logedIn = true;
    }
  }

  getProfile() {
    this.api.getMyProfile(localStorage.getItem('uid')).then((data: any) => {
      console.log('userdata', data);
      if (data) {
        this.name = data.fullname;
        this.photo = data && data.cover ? data.cover : 'assets/images/user.png';
        this.id = data.uid;
      }
      const city = JSON.parse(localStorage.getItem('selectedCity'));
      console.log(city);
      if (city && city.name) {
        this.cityName = city.name;
        this.cityId = city.id;
      }
    }).catch(error => {
      console.log(error);
    });
  }

  // Routing header
  goHome(): void {
    this.router.navigate(['home']);
  }
  goProducts(): void {
    const navData: NavigationExtras = {
      queryParams: {
        id: localStorage.getItem('restId')
      }
    };
    this.router.navigate(['category'], navData);
  }
  goAboutus(): void {
    this.router.navigate(['home']);
  }
  goContactus(): void {
    this.router.navigate(['home']);
  }
  login(): void {
    this.router.navigate(['login']);
  }
  logout(): void {
    this.api.logout().then((data) => {
      localStorage.removeItem('uid');
      this.logedIn = false;
      this.router.navigate(['logout']);
    }).catch(error => {
      console.log(error);
    });
  }
  goAccount(): void {
    this.router.navigate(['account']);
  }
  historyDetail(): void {
    this.router.navigate(['history']);
  }

  changeLocation() {
    document.getElementById('btnClickHeader').click();
  }

  getDetail(event): void {
    const city = JSON.parse(localStorage.getItem('selectedCity'));
    console.log(city);
    if (city && city.name) {
      this.cityName = city.name;
      this.cityId = city.id;
    }
    document.getElementById('dismisButtonHeader').click();
  }

  openDetails() {
    const navData: NavigationExtras = {
      queryParams: {
        id: localStorage.getItem('restId')
      }
    };
    this.router.navigate(['rest-details'], navData);
  }
}
